module.exports = __webpack_public_path__ + "img/arrow-right.70c97324.svg";